import httpClient from './httpClient';
const PostGetIssuerDetail = req => httpClient.post('/paotang/PostGetIssuerDetail', req);
const PostGetFileDownload = req => httpClient.post('/paotang/PostGetFileDownload', req, "", { responseType: 'arraybuffer' });

export default {
    PostGetIssuerDetail,
    PostGetFileDownload
};
